module.exports = __webpack_public_path__ + "static/media/puck2.b2e8e855.png";